import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faHome,
  faMicrophone,
  faPenToSquare,
} from "@fortawesome/free-solid-svg-icons";
import { URL } from "../../routes/url";

export const dataMenuClient: {
  title: string;
  to: string;
  icon: JSX.Element;
}[] = [
  {
    title: "Trang chủ",
    to: URL.CLIENT.HOME,
    icon: <FontAwesomeIcon icon={faHome} size="1x" />,
  },
  {
    title: "Bài viết",
    to: URL.CLIENT.POST,
    icon: <FontAwesomeIcon icon={faPenToSquare} size="1x" />,
  },
  {
    title: "Podcast",
    to: URL.CLIENT.PODCAST,
    icon: <FontAwesomeIcon icon={faMicrophone} size="1x" />,
  },
];

export const dataPodcast = [
  {
    urlPodcast: "https://www.youtube.com/watch?v=bQTmY1fFqWg",
    image:
      "https://i.ytimg.com/vi/bQTmY1fFqWg/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLB1hrbV644asM7D6U1WfB9ZawedCA",
  },
  {
    urlPodcast:
      "https://www.youtube.com/watch?v=hZTehTRzY50&list=PLwhaSxUyu05dbvCOeglBN29lYYpTl29vP&index=12&t=298s",
    image:
      "https://i.ytimg.com/vi/hZTehTRzY50/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLANiYrC2l7wwfzPHp9vFkSBFaX8kA",
  },
  {
    urlPodcast: "https://www.youtube.com/watch?v=30DaVTLQ7ao&t=3904s",
    image:
      "https://i.ytimg.com/vi/30DaVTLQ7ao/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLAkujhvl05ZXbzL4nij3AnpaR9z4w",
  },
  {
    urlPodcast: "https://www.youtube.com/watch?v=HG6WJBQ2t0I&t=638s",
    image:
      "https://i.ytimg.com/vi/HG6WJBQ2t0I/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLB9jamN9rL-wDuLQRJ3lOkRWgz_3g",
  },
  {
    urlPodcast: "https://www.youtube.com/watch?v=PmQUFWVXAY0",
    image:
      "https://i.ytimg.com/vi/PmQUFWVXAY0/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLBs7gLKmulpbywkhacXHjs61wFdJg",
  },
  {
    urlPodcast:
      "https://www.youtube.com/watch?v=oW-DXQ8DElA&list=PLwhaSxUyu05cyrOyEh18jpFD6kXIvUKS-&index=11",
    image:
      "https://i.ytimg.com/vi/oW-DXQ8DElA/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDRYk7NyuohooJVLhQVVbvPljUDog",
  },
  {
    urlPodcast: "https://www.youtube.com/watch?v=5IfGwhdBV5s",
    image:
      "https://i.ytimg.com/vi/5IfGwhdBV5s/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLDRr3COwXFok0d7Y_Wh7D73A-TMbw",
  },
  {
    urlPodcast:
      "https://www.youtube.com/watch?v=4O3Cs7lGqaA&list=PLwhaSxUyu05cyrOyEh18jpFD6kXIvUKS-&index=6",
    image:
      "https://i.ytimg.com/vi/4O3Cs7lGqaA/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLCHYi5XC_89nWg5DgTCg8g_In-_ig",
  },
  {
    urlPodcast: "https://www.youtube.com/watch?v=fRAIMVQtDYU&t=616s",
    image:
      "https://i.ytimg.com/vi/fRAIMVQtDYU/hq720.jpg?sqp=-oaymwEcCNAFEJQDSFXyq4qpAw4IARUAAIhCGAFwAcABBg==&rs=AOn4CLA_1Em-pJqRoMICjTfV9XwHozR7Wg",
  },
];

export const dataPodcast2 = [
  {
    urlPodcast: "https://www.youtube.com/",
    image:
      "https://yt3.googleusercontent.com/584JjRp5QMuKbyduM_2k5RlXFqHJtQ0qLIPZpwbUjMJmgzZngHcam5JMuZQxyzGMV5ljwJRl0Q=s900-c-k-c0x00ffffff-no-rj",
  },
  {
    urlPodcast: "https://www.udemy.com/",
    image: "https://s.udemycdn.com/meta/default-meta-image-v2.png",
  },
  {
    urlPodcast: "https://fullstack.edu.vn/",
    image:
      "https://yt3.googleusercontent.com/UsflU74uvka_3sejOu3LUGwzOhHJV0eIYoWcvOfkOre_c12uIN4ys-QqRlAkbusEmbZjTA-b=s900-c-k-c0x00ffffff-no-rj",
  },
  {
    urlPodcast: "https://fonos.vn/",
    image:
      "https://play-lh.googleusercontent.com/TIJDBGdw5OzKrTiSNi7Vx32a0929p7XyedLclsz9ZuyAbe5UhIdD9YdpfhFgRTsKpr4",
  },
  {
    urlPodcast: "https://www.duolingo.com/learn",
    image:
      "https://play-lh.googleusercontent.com/iaJR-64YmYN9iKp6Mcp6WAHtSws1OZlpa07smgZI_nIdRzsvjU3D6qZLENTJm3pqsg",
  },
];

export const dataNotify = [
  {
    title: "Thông báo nghỉ lễ 30/4 và 1/5 ",
    status: true,
    loading: false,
    since_date: "2024-05-12T05:28:13.546Z",
    content:
      "Công chức, viên chức được nghỉ 05 ngày liên tục từ thứ Bảy ngày 27/4/2024 đến hết thứ Tư ngày 01/5/2024 (làm bù vào ngày thứ Bảy 04/5/2024).",
  },
  {
    title: "Thông báo nghỉ lễ 30/4 và 1/5 ",
    status: true,
    loading: false,
    since_date: "2024-05-12T05:28:13.546Z",
    content:
      "Công chức, viên chức được nghỉ 05 ngày liên tục từ thứ Bảy ngày 27/4/2024 đến hết thứ Tư ngày 01/5/2024 (làm bù vào ngày thứ Bảy 04/5/2024).",
  },
  {
    title: "Thông báo nghỉ lễ 30/4 và 1/5 ",
    status: true,
    loading: false,
    since_date: "2024-05-12T05:28:13.546Z",
    content:
      "Công chức, viên chức được nghỉ 05 ngày liên tục từ thứ Bảy ngày 27/4/2024 đến hết thứ Tư ngày 01/5/2024 (làm bù vào ngày thứ Bảy 04/5/2024).",
  },
  {
    title: "Thông báo nghỉ lễ 30/4 và 1/5 ",
    status: true,
    loading: false,
    since_date: "2024-05-12T05:28:13.546Z",
    content:
      "Công chức, viên chức được nghỉ 05 ngày liên tục từ thứ Bảy ngày 27/4/2024 đến hết thứ Tư ngày 01/5/2024 (làm bù vào ngày thứ Bảy 04/5/2024).",
  },
  {
    title: "Thông báo nghỉ lễ 30/4 và 1/5 ",
    status: true,
    loading: false,
    since_date: "2024-05-12T05:28:13.546Z",
    content:
      "Công chức, viên chức được nghỉ 05 ngày liên tục từ thứ Bảy ngày 27/4/2024 đến hết thứ Tư ngày 01/5/2024 (làm bù vào ngày thứ Bảy 04/5/2024).",
  },
  {
    title: "Thông báo nghỉ lễ 30/4 và 1/5 ",
    status: true,
    loading: false,
    since_date: "2024-05-12T05:28:13.546Z",
    content:
      "Công chức, viên chức được nghỉ 05 ngày liên tục từ thứ Bảy ngày 27/4/2024 đến hết thứ Tư ngày 01/5/2024 (làm bù vào ngày thứ Bảy 04/5/2024).",
  },
];
